<template>
  <div>
    <LayoutBanner
      activeNav="联系我们"
      :topColor="topColor"
      bannerType="header index"
      :height='250'
    />
    <div class="container">
      <div class="repeatTitle">
        <div class="title_text art_info_line">
          <h1>联系我们</h1>
          <h2>Literary Information</h2>
        </div>
      </div>

      <div class="map">
        <baidu-map
          style="height: 100%"
          :center="baiduMap.location"
          :zoom="baiduMap.zoom"
          @ready="handler"
        >
          <bm-marker
            :position="baiduMap.location"
            :dragging="true"
            @click="infoWindowOpen"
          >
            <bm-info-window
              :show="baiduMap.show"
              @close="infoWindowClose"
              @open="infoWindowOpen"
            >
              <div>四川省文学艺术界联合会</div>
              <div>地址：四川省成都市红星路二段85号</div>
            </bm-info-window>
          </bm-marker>
        </baidu-map>
      </div>

      <div class="contact">
        <!-- <div class="left">
          <img src="" alt="" />
          <div>四川文艺网 微信二维码</div>
        </div> -->
        <ul class="right">
          <li>
            <img src="../../assets/images/contact/icon-Contact-address@2x.png" alt="" />
            <span class="redText">地址</span>
            <span class="blackText">四川省成都市红星路二段85号（610012）</span>
          </li>
          <!-- <li>
            <img src="../../assets/images/contact/icon-Contact-phone@2x.png" alt="" />
            <span class="redText">电话</span>
            <span class="blackText">18347452934</span>
          </li>
          <li>
            <img src="../../assets/images/contact/icon-Contact-email@2x.png" alt="" />
            <span class="redText">邮箱</span>
            <span class="blackText">scwyw2010@163.com</span>
          </li> -->
        </ul>
      </div>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
export default {
  data() {
    return {
      topColor: "background-color: rgba(0, 0, 0, 0.3)",
      baiduMap: {
        location: {
          lng: 0,
          lat: 0,
        },
        zoom: 3,
        show: true,
      },
    };
  },
  mounted() {
    this.initScroll();
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //初始化百度地图
    handler({ BMap, map }) {
      this.baiduMap.location.lng = 104.09073;
      this.baiduMap.location.lat = 30.66606;
      this.baiduMap.zoom = 20;
    },
    //监听地图点击
    infoWindowClose() {
      this.baiduMap.show = false;
    },
    infoWindowOpen() {
      this.baiduMap.show = true;
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
  .repeatTitle {
    display: flex;
    justify-content: center;
    margin-top: 62px;
    margin-bottom: 37px;
    .title_text {
      text-align: center;
      background: url("../../assets/images/index/title-line1@2x.png") no-repeat
        59px 0px;
      background-size: contain;
      padding: 10px;
    }

    h1 {
      font-size: 26px;
      padding-top: 6px;
    }

    h2 {
      font-size: 14px;
      color: #989898;
      font-weight: normal;
    }

    .art_info_line {
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 500px;
        height: 2px;
        background: url("../../assets/images/index/title-line-2left@2x.png")
          no-repeat;
        position: absolute;
        background-size: contain;
        left: -490px;
        top: 30px;
      }

      &::before {
        content: "";
        display: block;
        width: 500px;
        height: 2px;
        background: url("../../assets/images/index/title-line-2right@2x.png")
          no-repeat;
        position: absolute;
        background-size: contain;
        right: -490px;
        top: 30px;
      }
    }
  }

  .map {
    height: 400px;
    margin-bottom: 90px;
  }

  .contact {
    display: flex;
    // justify-content: space-between;
    justify-content: center;
    width: 760px;
    margin: 0 auto;
    margin-bottom: 150px;
    .left {
      width: 244px;
      img {
        width: 100%;
        height: 244px;
        margin-bottom: 10px;
      }
      div {
        text-align: center;
        color: #333333;
      }
    }

    .right {
        li{
            height: 64px;
            display: flex;
            margin-bottom: 26px;
            align-items: center;
            img{
                width: 64px;
                height: 100%;
                margin-right: 16px;
            }
            .redText{
                font-size: 18px;
                color: #A32225;
                font-weight: bold;
                margin-right: 12px;
            }
            .blackText{
                color: #333333;
            }
        }
    }
  }
}
</style>